import * as React from 'react';

export interface TreeArrowProps {
  isExpanded: boolean;
}

export const TreeArrow: React.SFC<TreeArrowProps> = ({ isExpanded }) =>
  isExpanded ? (
    <svg width="10" height="5" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0l5 5 5-5H0z" fill="#626262" />
    </svg>
  ) : (
    <svg width="5" height="10" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 10l5-5-5-5v10z" fill="#626262" />
    </svg>
  );



// WEBPACK FOOTER //
// ./src/components/timeline/TreeArrow.tsx